const MARK_APPLICATION_SUBMITTED = 'classpass/careers/MARK_APPLICATION_SUBMITTED';

const initialState = {
  submittedApplications: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case MARK_APPLICATION_SUBMITTED:
      return {
        ...state,
        submittedApplications: {
          [action.id]: true,
        },
      };
    default:
      return state;
  }
}

export const markApplicationSubmitted = id => ({ type: MARK_APPLICATION_SUBMITTED, id });
